import { useEffect } from "react";
import ServiceUnavailable from "../../components/ServiceUnavailable/ServiceUnavailable";
import { useLocation, useNavigate } from "react-router-dom";
import useReactGASend from "../../hooks/useReactGASend";

const BlockPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { makeEventTrackFn } = useReactGASend();

  useEffect(() => {
    makeEventTrackFn({
      category: "event",
      action: "서비스 이용 불가 페이지 인입",
    });
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      navigate("/exit");
    };

    window.history.pushState(null, "", location.pathname);
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname, navigate]);

  const description = (
    <>
      해당 기능을 사용할수 없는 브라우저 입니다 <br /> OS 또는 웹 브라우저의
      버전을 업그레이드 하세요.
    </>
  );

  return (
    <ServiceUnavailable
      title="서비스 이용 불가"
      description={description}
      button={"처음으로"}
    />
  );
};

export default BlockPage;
